module.exports = __webpack_public_path__ + "img/orcaex.71fe4d3c.png";